import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from '../../../components/PageTitleWrapper';
import EditBannerHeader from './EditBannerHeader';
import { Container, Grid } from '@mui/material';
import Footer from '../../../components/Footer';
import BannerForm from '../../../components/banner/BannerForm';

function EditBanner() {
  return (
    <>
      <Helmet>
        <title>Edit Banner</title>
      </Helmet>
      <PageTitleWrapper>
        <EditBannerHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <BannerForm />
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default EditBanner;
